import { render, staticRenderFns } from "./LabelAddModal.vue?vue&type=template&id=fab3639e&"
import script from "./LabelAddModal.vue?vue&type=script&lang=js&"
export * from "./LabelAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports